import { CategoryGrid } from "~/types";
import NoImage from '~/assets/no_image_big.jpg';
import NoImageMultiStore from '~/assets/missingImage.jpg';
import { multiStore } from "../../../setup/settings/__product";

type CategoryGridCardProps =
    {
        c: CategoryGrid;
    }

export function CategoryGridCard({ c }: CategoryGridCardProps) {
    const goCategoryGrid = (i: CategoryGrid) => {
        if (c.customFields?.redirectUrl) return c.customFields.redirectUrl;
        if (c.customFields?.enableInteractiveCategoryList) return `/collections/${c.handle}`;
        return `/collections/${c.handle}/products`;
    }

    return (
        <a className='homeCategories__card--link' href={goCategoryGrid(c)}>
            {c.image != null && c.image.Src != "" && c.image.Src != null ?
                <img className='homeCategories__img' src={c.image.Src} />
                :
                <img className='homeCategories__img' src={multiStore? NoImageMultiStore : NoImage} />
            }
            <button className="homeCategories__btn">{c.name}</button>
        </a>
    )
}